import { ReactEventHandler } from 'react';

const EVENTS_TO_PREVENT_BUBBLING = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOver',
    'onMouseOut',
    'onMouseUp',
    'onKeyDown',
    'onKeyPress',
    'onKeyUp',
    'onBlur',
    'onChange',
    'onFocus',
    'onInput',
    'onInvalid',
    'onReset',
    'onSelect',
    'onSubmit',
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop',
    'onCopy',
    'onCut',
    'onPaste',
    'onWheel',
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart',
] as const;

type EventHandlersMap = Record<(typeof EVENTS_TO_PREVENT_BUBBLING)[number], ReactEventHandler>;

const bubblingCancelHandler: ReactEventHandler = (event) => event.stopPropagation();

export const useNoBubbling = (props?: Partial<EventHandlersMap>): EventHandlersMap => {
    return EVENTS_TO_PREVENT_BUBBLING.reduce((result, eventName) => {
        result[eventName] =
            props && eventName in props
                ? (event) => {
                      (props as unknown as EventHandlersMap)[eventName](event);
                      bubblingCancelHandler(event);
                  }
                : bubblingCancelHandler;
        return result;
    }, {} as EventHandlersMap);
};
